var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTextSquare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.70117H12M7 12.2012H15M7 18.2012V20.5367C7 21.0695 7 21.3359 7.10923 21.4728C7.20422 21.5918 7.34827 21.661 7.50054 21.6609C7.67563 21.6607 7.88367 21.4942 8.29976 21.1614L10.6852 19.253C11.1725 18.8632 11.4162 18.6682 11.6875 18.5296C11.9282 18.4066 12.1844 18.3168 12.4492 18.2624C12.7477 18.2012 13.0597 18.2012 13.6837 18.2012H16.2C17.8802 18.2012 18.7202 18.2012 19.362 17.8742C19.9265 17.5866 20.3854 17.1276 20.673 16.5631C21 15.9214 21 15.0813 21 13.4012V8.00117C21 6.32101 21 5.48094 20.673 4.8392C20.3854 4.27471 19.9265 3.81577 19.362 3.52815C18.7202 3.20117 17.8802 3.20117 16.2 3.20117H7.8C6.11984 3.20117 5.27976 3.20117 4.63803 3.52815C4.07354 3.81577 3.6146 4.27471 3.32698 4.8392C3 5.48094 3 6.32101 3 8.00117V14.2012C3 15.1311 3 15.5961 3.10222 15.9776C3.37962 17.0129 4.18827 17.8215 5.22354 18.0989C5.60504 18.2012 6.07003 18.2012 7 18.2012Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTextSquare2);
export default __webpack_public_path__ + "static/media/message-text-square2.a8b638385f4d38607857100e761cc20d.svg";
export { ForwardRef as ReactComponent };